import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotVideosSection from './components/HotVideosSection';
import LatestVideosSection from './components/LatestVideosSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <CategorySection />
      <HotVideosSection />
      <LatestVideosSection />
      <FaqSection />
      <CtaSection />
    </main>
  );
}